const ConfigAttribute = ({ children }) => {
    return <div className="my-2 unselectable">{children}</div>;
};

export default ConfigAttribute;
